import {NewPlacement} from '@/common/interface/placement.data.model';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {environment} from 'environments/environment';
import {ToastrService} from 'ngx-toastr';
import {catchError, Observable, throwError} from 'rxjs';
export interface House {
    houseId: number;
    houseName: string;
}
export interface PlacementFeedingRecord {
    id: number;
    cycleId: number;
    farmHouseId: number;
    quantity: number;
    dateTime: string;
    createdBy: number;
    createdOnUtc: string;
    updatedOnUtc: string | null;
}

export interface AddActivePlacementFeedingRecordRequest {
    id?: number;
    cycleId: number;
    farmHouseId: number;
    quantity: number;
    dateTime: string;
    createdBy: number;
}

export interface UpdateActivePlacementFeedingRecordRequest {
    id: number;
    cycleId: number;
    farmHouseId: number;
    quantity: number;
    dateTime: string;
    createdBy: number;
}
export interface GetCyclesByFarmAndHouseRequest {
    farmId: number;
    houseId: number;
    cycles: {
        id: number;
        name: string;
    }[];
}

export interface DeleteActivePlacementFeedingRecordRequest {
    id: number;
}

export type DeleteActivePlacementFeedingRecordResponse = 'OK';
// Request payload

// Common activity structure
export interface Activity {
    date: string; // ISO string, e.g. "2025-08-12T00:00:00"
    time: string; // e.g. "12:52"
    type: 'Medication' | 'Vaccination' | 'Disinfection';
    product: string;
    quantity: number;
}

// Response payload
export interface GetCycleActivitiesResponse {
    medication: Activity[];
    vaccination: Activity[];
    disinfection: Activity[];
}

@Injectable({
    providedIn: 'root'
})
export class PlacementService {
    constructor(
        private httpClient: HttpClient,
        private router: Router,
        private toastr: ToastrService
    ) {}
    private apiUrl = environment.apiUrl;
    addPlacement(placement: NewPlacement): Observable<any> {
        return this.httpClient
            .post(`${this.apiUrl}/Placements/AddPlacement`, placement)
            .pipe(catchError(this.error));
    }
    getPlacementList(filterParams: any): Observable<any> {
        return this.httpClient
            .post(`${this.apiUrl}/Placements/GetPlacementList`, filterParams)
            .pipe(catchError(this.error));
    }
    getMortalityTypeList(): Observable<any> {
        return this.httpClient
            .get(`${this.apiUrl}/Placements/GetMortalityTypeList`)
            .pipe(catchError(this.error));
    }
    getPlacementById(placementId: number): Observable<any> {
        return this.httpClient
            .get(`${this.apiUrl}/Placements/GetPlacementById?id=${placementId}`)
            .pipe(catchError(this.error));
    }
    closePlacementById(placementId: number): Observable<any> {
        return this.httpClient
            .post(
                `${this.apiUrl}/Placements/CloseCycle?id=${placementId}`,
                null
            )
            .pipe(catchError(this.error));
    }
    getPlacementDetailById(placementId: number): Observable<any> {
        return this.httpClient
            .get(
                `${this.apiUrl}/Placements/GetPlacementDetailById?id=${placementId}`
            )
            .pipe(catchError(this.error));
    }
    deletePlacement(placementId: number): Observable<any> {
        return this.httpClient
            .delete(
                `${this.apiUrl}/Placements/DeletePlacement?id=${placementId}`
            )
            .pipe(catchError(this.error));
    }

    updateChicksFeedingProgram(placementmodel: any): Observable<any> {
        return this.httpClient
            .post(
                `${this.apiUrl}/Placements/UpdateChicksFeeding`,
                placementmodel
            )
            .pipe(catchError(this.error));
    }
    addActivePlacementMortality(mortalityModel: any): Observable<any> {
        return this.httpClient
            .post(
                `${this.apiUrl}/Placements/AddActivePlacementMortality`,
                mortalityModel
            )
            .pipe(catchError(this.error));
    }
    getActivePlacementMortalitylistByPlacementId(
        placementId: number
    ): Observable<any> {
        return this.httpClient
            .get(
                `${this.apiUrl}/Placements/GetActivePlacementMortalityList?placementId=${placementId}`
            )
            .pipe(catchError(this.error));
    }
    getActivePlacementMedicationlistByPlacementId(
        placementId: number
    ): Observable<any> {
        return this.httpClient
            .get(
                `${this.apiUrl}/Placements/GetActivePlacementMedicationList?placementId=${placementId}`
            )
            .pipe(catchError(this.error));
    }
    addActivePlacementWeeklyBodyWeight(weeklyBodyWeight: any): Observable<any> {
        return this.httpClient
            .post(
                `${this.apiUrl}/Placements/AddActivePlacementAverageBodyWeight`,
                weeklyBodyWeight
            )
            .pipe(catchError(this.error));
    }
    getActivePlacementAverageWeightlistByPlacementId(
        placementId: number
    ): Observable<any> {
        return this.httpClient
            .get(
                `${this.apiUrl}/Placements/GetActivePlacementAverageWeightList?placementId=${placementId}`
            )
            .pipe(catchError(this.error));
    }
    getActivePlacementVaccinelistByPlacementId(
        placementId: number
    ): Observable<any> {
        return this.httpClient
            .get(
                `${this.apiUrl}/Placements/GetActivePlacementVaccineList?placementId=${placementId}`
            )
            .pipe(catchError(this.error));
    }
    GetActivePlacementVaccinationRecords(placementId: number): Observable<any> {
        return this.httpClient
            .get(
                `${this.apiUrl}/Placements/GetActivePlacementVaccinationRecords?placementId=${placementId}`
            )
            .pipe(catchError(this.error));
    }

    GetActivePlacementVaccinationData(placementId: number): Observable<any> {
        return this.httpClient
            .get(
                `${this.apiUrl}/Placements/GetActivePlacementVaccinationData?placementId=${placementId}`
            )
            .pipe(catchError(this.error));
    }

    addActivePlacementODOAverageWeight(weight: any): Observable<any> {
        return this.httpClient
            .post(
                `${this.apiUrl}/Placements/AddActivePlacementODOAverageBodyWeight`,
                weight
            )
            .pipe(catchError(this.error));
    }
    getActivePlacementAverageODOWeightlistByPlacementId(
        placementId: number
    ): Observable<any> {
        return this.httpClient
            .get(
                `${this.apiUrl}/Placements/GetActivePlacementODOWeightList?placementId=${placementId}`
            )
            .pipe(catchError(this.error));
    }

    getWeeklyBodyWeightMetricsList(cycleId: number): Observable<any> {
        return this.httpClient
            .get(
                `${this.apiUrl}/Placements/GetWeeklyBodyWeightMetricsList?cycleId=${cycleId}`
            )
            .pipe(catchError(this.error));
    }
    getBodyWeightMetrics(cycleId: number): Observable<any> {
        return this.httpClient
            .get(
                `${this.apiUrl}/Placements/GetBodyWeightMetrics?cycleId=${cycleId}`
            )
            .pipe(catchError(this.error));
    }

    getSummaryDetailsByPlacementId(placementId: number): Observable<any> {
        return this.httpClient
            .get(
                `${this.apiUrl}/Placements/GetSummaryDetailsByPlacementId?placementId=${placementId}`
            )
            .pipe(catchError(this.error));
    }
    getActivePlacementDisinfectionlist(placementid: any): Observable<any> {
        return this.httpClient
            .get(
                `${this.apiUrl}/Placements/GetPlacementDisinfectionList?placementId=${placementid}`
            )
            .pipe(catchError(this.error));
    }
    addActivePlacementVaccines(vaccine: any): Observable<any> {
        return this.httpClient
            .post(
                `${this.apiUrl}/Placements/AddActivePlacementVaccines`,
                vaccine
            )
            .pipe(catchError(this.error));
    }
    addActivePlacementMedication(medication: any): Observable<any> {
        return this.httpClient
            .post(
                `${this.apiUrl}/Placements/AddActivePlacementMedication`,
                medication
            )
            .pipe(catchError(this.error));
    }
    addActivePlacementDisinfectionInstruction(
        disinfectioninstruction: any
    ): Observable<any> {
        return this.httpClient
            .post(
                `${this.apiUrl}/Placements/AddActivePlacementDisinfection`,
                disinfectioninstruction
            )
            .pipe(catchError(this.error));
    }
    getChicksTypeList(): Observable<any> {
        return this.httpClient
            .get(`${this.apiUrl}/Placements/ChicksTypeList`)
            .pipe(catchError(this.error));
    }

    getTotalMortalities(placementId: number): Observable<any> {
        const params = {placementId: placementId.toString()};
        return this.httpClient
            .get(`${this.apiUrl}/Placements/TotalMortalities`, {params})
            .pipe(catchError(this.error));
    }

    // Handle Errors
    error(error: HttpErrorResponse) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            errorMessage = error.error.message;
        } else {
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }

        return throwError(() => {
            return errorMessage;
        });
    }

    getMedicationData(placementId: number): Observable<any> {
        return this.httpClient
            .get(`${this.apiUrl}/Placements/GetMedicationData`, {
                params: {placementId: placementId.toString()}
            })
            .pipe(catchError(this.error));
    }
    getCyclePerformanceMetrics(cycleId: number): Observable<any> {
        return this.httpClient
            .get(`${this.apiUrl}/Placements/GetCyclePerformanceMetrics`, {
                params: {cycleId: cycleId.toString()}
            })
            .pipe(catchError(this.error));
    }

    // APIs for Feeding Records and Houses
    getHousesByCycleId(cycleId: number): Observable<any> {
        return this.httpClient
            .get<House[]>(`${this.apiUrl}/Placements/GetHousesByCycle`, {
                params: {cycleId: cycleId}
            })
            .pipe(catchError(this.error));
    }

    getActiveBirdCount(placementId: number) {

    return this.httpClient.get<any>(
        `${this.apiUrl}/Placements/GetActiveBirdCount`,
        {
            params: {
                placementId: placementId
            }
        }
    );
}

    getActivePlacementFeedingRecordsById(
        placementId: number
    ): Observable<PlacementFeedingRecord[]> {
        return this.httpClient
            .get<PlacementFeedingRecord[]>(
                `${this.apiUrl}/Placements/GetActivePlacementFeedingRecordById`,
                {
                    params: {id: placementId}
                }
            )
            .pipe(catchError(this.error));
    }

    getAllActivePlacementFeedingRecordsByCycleId(
        cycleId: number,
        pageNumber: number = 1,
        pageSize: number = 20,
        filters?: {farmHouseId?: number; fromDate?: string; toDate?: string}
    ): Observable<{
        items: PlacementFeedingRecord[];
        meta: {totalCount: number; pageSize: number; currentPage: number; totalPages: number};
    }> {
        const params: Record<string, string | number | undefined> = {
            cycleId,
            pageNumber,
            pageSize
        };
        if (filters) {
            if (filters.farmHouseId !== undefined && filters.farmHouseId !== 0)
                params.farmHouseId = filters.farmHouseId;
            if (filters.fromDate) params.fromDate = filters.fromDate;
            if (filters.toDate) params.toDate = filters.toDate;
        }
        return this.httpClient
            .get<{
                items: PlacementFeedingRecord[];
                meta: {totalCount: number; pageSize: number; currentPage: number; totalPages: number};
            }>(`${this.apiUrl}/Placements/GetAllActivePlacementFeedingRecords`, {params})
            .pipe(catchError(this.error));
    }

    addActivePlacementFeedingRecord(
        request: AddActivePlacementFeedingRecordRequest
    ): Observable<any> {
        return this.httpClient
            .post<any>(
                `${this.apiUrl}/Placements/AddActivePlacementFeedingRecord`,
                request
            )
            .pipe(catchError(this.error));
    }

    updateActivePlacementFeedingRecord(
        request: UpdateActivePlacementFeedingRecordRequest
    ): Observable<any> {
        return this.httpClient
            .post<any>(
                `${this.apiUrl}/Placements/UpdateActivePlacementFeedingRecord`,
                request
            )
            .pipe(catchError(this.error));
    }

    deleteActivePlacementFeedingRecord(id: number): Observable<any> {
        return this.httpClient
            .delete<any>(
                `${this.apiUrl}/Placements/DeleteActivePlacementFeedingRecord`,
                {
                    params: {id: id}
                }
            )
            .pipe(catchError(this.error));
    }

    getCycleActivities(
        cycleId: number
    ): Observable<GetCycleActivitiesResponse> {
        return this.httpClient.get<GetCycleActivitiesResponse>(
            `${this.apiUrl}/Placements/GetCycleActivities?cycleId=${cycleId}`
        );
    }

    getCyclesByFarmAndHouse(
        farmId: number = 0,
        houseId: number = 0
    ): Observable<GetCyclesByFarmAndHouseRequest> {
        return this.httpClient.get<GetCyclesByFarmAndHouseRequest>(
            `${this.apiUrl}/Placements/GetCyclesByFarmAndHouse?farmId=${farmId}&houseId=${houseId}`
        );
    }
}
